import getProvincias from "components/business/provinciaSelector/getProvincias";

const getProvinciaLabel = (provinciaId: number | undefined): string => {
  if (!provinciaId) return "-";
  const prov = getProvincias().find((p) => p.value === provinciaId);
  return prov ? prov.label : "-";
};

export default getProvinciaLabel;
